import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AnalysisToolService = {
    occurrencesReasons: async (payload) => axios.post(API_URL + "/analysisTool/get/occurrencesReasons", payload).then(({ data }) => data.data).catch((err) => { throw err }),
    citiesItems: async () => axios.get(API_URL + `/analysisTool/get/citiesItems`).then(({ data }) => data.data).catch((err) => { throw err }),
    layerItems: async () => axios.get(API_URL + `/analysisTool/get/layerItems`).then(({ data }) => data.data).catch((err) => { throw err }),
    pointItems: async () => axios.get(API_URL + `/analysisTool/get/pointItems`).then(({ data }) => data.data).catch((err) => { throw err }),
    analysisConfig: async () => axios.get(API_URL + `/analysisTool/analysis/config`).then(({ data }) => data).catch((err) => { throw err }),
    openSentryviewOccurrence: async (occId) => axios.get(`${API_URL}/analysisTool/openSentryviewOccurrence/${occId}`).then(({ data }) => data).catch((err) => { throw err }),
};

export default AnalysisToolService;

